export default __webpack_public_path__ + "static/media/Payment.9e378c0d.svg";